export default __webpack_public_path__ + "static/media/BatteryImg.64125523.svg";